/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import profile from "../Image/Suraj Profile Photo (2).jpg";
import resume from "../Resume/Suraj-Kamat-Resume.pdf"
export const About = () => {

    const handleResume = () => {
        window.open("https://drive.google.com/file/d/1fCow8sfk-xgyl8HhRI0tXiwCVz3AAeMO/view?usp=sharing",
            "_blank")
    }
    return (
        <section className="about section" id="about">
            <div className="heading">
                <h2>About Me</h2>
                {/* <!-- <span>Introduction</span> --> */}
            </div>

            <div className="about-container">
                <div className="home-img-main">
                    <img className="home-img" src={profile} alt="alok" />

                </div>
                <div className="about-text" id="user-detail-intro">
                    <p> Aspiring Full Stack Web Developer who can write production-ready code using React.js, Node.js, HTML, JavaScript, Chakra UI, and CSS. Passionate about coding, and managing the team. Looking forward to joining a progressive organization with opportunities to work on significant projects.</p>
                    <div className="information">
                        <div className="info-box">
                            <i className='bx bxs-user'></i>
                            <span></span> <h3>Suraj Kumar Kamat</h3>
                        </div>

                        <div className="info-box">
                            <i className='bx bxs-phone'></i>
                            <span id="contact-phone">8584007663</span>
                        </div>
                        <div className="info-box">
                            <i className='bx bxs-envelope'></i>
                            <span id="contact-email">surajkrsr98@gmail.com</span>
                        </div>

                    </div>

                    {/* <button className="resume-button" id="resume-button-2"><a href={resume} id="resume-link-2" download="Suraj_Kamat_Resume" target="_blank">Resume</a></button> */}

                    <a onClick={handleResume} id="resume-link-2" href={resume} target="_blank"
                        download="Suraj_Kamat_Resume"> <button className="resume-button" id="resume-button-2">Resume</button> </a>
                    {/* <a id="resume-link-2" href={resume} download="Suraj_Kamat_Resume" target="_blank">
                        <button className="resume-button" id="resume-button-2">Resume</button></a> */}
                </div>
            </div>
        </section>
    )
}
